<div class="ad-step1">
    <div class="container">
        <div class="page-contents">
            <div class="heading">
                <h1>Choose your payment options</h1>
            </div>
            <div class="form-contents mt-5">
                <form action='#'>
                    <div class="row pb-3">
                        <div class="col ad-para">
                            <h4 class="pb-3" *ngIf="property">Your Property ID is - {{ property.aliasId }}</h4>
                            <p>Use the Property ID for payment purpose.</p>
                        </div>
                    </div>
                    <div class="pb-5" *ngIf="adPlans.length > 0 && selectedPlan">
                        <div class="row">
                            <div class="col-sm-12">
                                <p class="strong">Advertisement Plans:</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 mb-4" *ngFor="let adPlan of adPlans">
                                <div class="card" (click)="selectPlan(adPlan.id)" [ngClass]="{'selected': selectedPlan.id === adPlan.id}">
                                    <div class="card-title">
                                        {{ adPlan.plan }}
                                    </div>
                                    <div class="card-icon">
                                        <img src="assets/basic-01.png">
                                    </div>
                                    <span class="card-message" *ngIf="adPlan.id != selectedPlan.id">Use this plan</span>
                                    <span class="card-message" *ngIf="adPlan.id == selectedPlan.id">Selected plan</span>
                                    <div class="card-info">
                                        Rs. {{ adPlan.price }}<br>
                                        <span class="card-time">{{ adPlan.validityDays }} days</span>
                                    </div>
                                    <div class="underline"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-sm-12">
                            <p class="strong">Payment Methods:</p>
                        </div>
                        <!-- eSewa hidden for now -->
                        <div class="col-md-3" *ngIf="false">
                            <div class="payment-type">
                                <form #form [action]="url" method="POST">
                                    <input [(ngModel)]="esewaPaymentParams.tAmt" name="tAmt" type="hidden">
                                    <input [(ngModel)]="esewaPaymentParams.amt" name="amt"  type="hidden">
                                    <input [(ngModel)]="esewaPaymentParams.txAmt" name="txAmt"  type="hidden">
                                    <input [(ngModel)]="esewaPaymentParams.psc" name="psc"  type="hidden">
                                    <input [(ngModel)]="esewaPaymentParams.pdc" name="pdc"  type="hidden">
                                    <input [(ngModel)]="esewaPaymentParams.scd" name="scd"  type="hidden">
                                    <input [(ngModel)]="esewaPaymentParams.pid" name="pid"  type="hidden">
                                    <input [(ngModel)]="esewaPaymentParams.su" name="su"  type="hidden">
                                    <input [(ngModel)]="esewaPaymentParams.fu" name="fu"  type="hidden">
                                    <button mat-button type="submit" (click)="form.submit()"><img src="assets/esewa.png" alt=""><br><span class="button-text">E-sewa</span></button>
                                </form>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="payment-type">
                                <button mat-button (click)="payInCash()"><img src="assets/pay-in-cash.png" alt=""><br><span class="button-text">Pay In Cash</span></button>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="payment-type">
                                <button mat-button (click)="bankPayment()"><img src="assets/bank.png" alt=""><br><span class="button-text">Bank - Deposit</span></button>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="payment-type">
                                <button mat-button (click)="bankTransfer()"><img src="assets/bank-transfer.png" alt=""><br><span class="button-text">Bank - Transfer</span></button>
                            </div>
                        </div>

                    </div>
                    <div class="row pt-5 justify-content-end px-3" *ngIf="property">
                        <a [routerLink]="'/edit-property/'+property.id" mat-raised-button  class="theme-button">Pay later &nbsp;&nbsp;&nbsp;→</a>
                        <p style="font-size: medium; text-align: left; line-height: 1.8; font-weight: bold;" class="py-4 pr-4">You can choose to pay later and come back to this page from your profile. However, your ad will not be published until payment is made.</p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
